// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"6887dec0","55":"b55550e3","453":"8a88626b","732":"54d3264d","977":"7296a1df"}[chunkId] + ".chunk.js";
};